const CircleSVG = () => {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4.5" cy="4.5" r="4" fill="#563EAF" stroke="#FF868D" />
    </svg>
  );
};

export default CircleSVG;
